module.exports = "/_next/static/resources/photo-1-7c0557ca39b337867fa33810a2a77a9e.webp";